var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px"}},[_c('ul',_vm._l((_vm.bidding),function(i){return _c('li',{key:i.time,staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(i.time))]),_c('div',[_vm._v(_vm._s(i.msg))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }